import { useMemo } from 'react'
import { assetsCollectionElement, IEcommerceAnswerSchema } from '../types.ts'

// The product's assets as one flat list: main photo, then the gallery, then the 3D model. A
// position in it is what the timeline reports as `target`, so the order is shared by every store.
export default function useAssetsCollectionBuilder(product: IEcommerceAnswerSchema): assetsCollectionElement[] {
  return useMemo(
    () => [
      ...(product.image ? [product.image] : []),
      ...(product.gallery || []),
      ...(product.view3d ? [product.view3d] : [])
    ],
    [product]
  )
}
